// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___dqzJo","carousel":"styles__carousel___3dGMC","carousel-title":"styles__carousel-title___2nXdc","carousel-container":"styles__carousel-container___33GgR"};